"use client";
import { cn as e } from "../../design/cn.js";
import { Checkbox as t } from "../../design/forms/checkbox/index.js";
import { useDataTable as n } from "./use-data-table.js";
import { TableBody as r, TableCell as i, TableHead as a, TableHeader as o, TableRoot as s, TableRow as c } from "./table-primitives.js";
import { TableCardHeader as l, TableCardRoot as u } from "./DataTableCard.js";
import { EXPANDED_ACCENT_BAR as d, EXPANDED_PANEL_BG as f, ExpandToggle as ee, ExpandedRow as te } from "./DataTableExpandable.js";
import { BulkActionsBar as p } from "./DataTableBulkBar.js";
import { DataTablePagination as ne } from "./DataTablePagination.js";
import { DataTableViewOptions as m } from "./DataTableViewOptions.js";
import { EditableCell as re } from "./EditableCell.js";
import { checkboxCell as ie, expandCell as ae } from "./table-cva.js";
import { DndContext as oe, DragHandle as se, SortableContext as ce, closestCenter as le, useDndReorder as ue, useSortableRow as de, verticalListSortingStrategy as fe } from "./DataTableDraggable.js";
import "react";
import { Fragment as h, jsx as g, jsxs as _ } from "react/jsx-runtime";
import { motion as pe } from "framer-motion";
import { flexRender as me } from "@tanstack/react-table";
// src/components/data-table/DataTable.tsx
var he = (e) => e instanceof Element && e.closest("a, button, input, select, textarea, label, [role='menuitem']") !== null;
function v(e) {
	return e?.meta ?? {};
}
var ge = (e) => e.textAlign ?? (e.numeric ? "right" : void 0);
function _e(e, t = "") {
	switch (e) {
		case "left": return "text-left";
		case "right": return "text-right";
		case "center": return "text-center";
		default: return t;
	}
}
function y(e, t, n, r) {
	return e.hugContent ? {
		width: "1px",
		minWidth: "auto",
		maxWidth: "none"
	} : {
		width: t?.size == null ? void 0 : n && r ? r() : t.size,
		minWidth: t?.minSize ?? void 0,
		maxWidth: t?.maxSize ?? void 0
	};
}
function ve(e) {
	if (typeof e == "number") return e;
	if (typeof e == "string") {
		let t = parseFloat(e);
		if (!Number.isNaN(t)) return t;
	}
	return 200;
}
function ye(e) {
	let t = e.map(() => ({
		side: null,
		offset: 0
	})), n = 0;
	e.forEach((e, r) => {
		e.pinLeft && (t[r] = {
			side: "left",
			offset: n
		}, n += e.width);
	});
	let r = 0;
	for (let n = e.length - 1; n >= 0; --n) e[n].pinRight && (t[n] = {
		side: "right",
		offset: r
	}, r += e[n].width);
	return t;
}
function be(e) {
	return e.side ? {
		position: "sticky",
		[e.side]: `${e.offset}px`
	} : {};
}
function xe(t, n) {
	return e("sticky bg-card", n === "header" ? "z-20" : "z-10", t === "left" ? "shadow-[2px_0_4px_-2px_rgba(0,0,0,0.15)]" : void 0, t === "right" ? "shadow-[-2px_0_4px_-2px_rgba(0,0,0,0.15)]" : void 0);
}
function b({ columns: b, data: Se, size: Ce = "md", density: we = "compact", variant: x = "default", sticky: S, truncateCells: Te, truncateSingleLineOnly: Ee, enableRowSelection: C = !1, rowSelection: De, onRowSelectionChange: Oe, selectedRowIds: ke, onSelectedRowIdsChange: Ae, enableSorting: w = !0, sorting: je, onSortingChange: Me, onRowClick: T, rowHref: E, rowClassName: D, rowLabel: Ne, className: Pe, tableCard: O, slots: Fe, components: Ie, noDataText: Le = "No results.", expandable: k, subrows: A, pagination: Re, enableColumnResizing: j = !1, columnResizeMode: ze = "onChange", enableColumnReorder: M = !1, onColumnOrderChange: Be, initialColumnOrder: Ve, stickyHeader: He = !1, stickyHeaderOffset: N = 0, selectionScope: P = "page", getRowId: Ue, loading: We, error: Ge, emptyContent: Ke, states: F, bulkActions: I, bulkBarPosition: qe = "top", enableRowReorder: L = !1, onRowReorder: Je, editable: R, showColumnVisibility: Ye = !1, containerClassName: Xe, "aria-label": Ze, "aria-labelledby": Qe }) {
	let z = we ? we === "compact" ? "sm" : "md" : Ce, B = Fe ?? Ie ?? {}, V = B.TD ?? i, H = B.TH ?? a, U = B.TR ?? c, $e = B.Thead ?? o, et = B.TBody ?? r, { table: W, expandedRows: tt, editingCell: nt, setEditingCell: G, pagination: rt, setPagination: it, handleToggleExpand: at, extractRowId: K, draggedColumnId: ot, dragOverColumnIndex: st, isColumnReordering: q, columnDragHandlers: J, isClient: ct, pager: Y, resolvedPageSize: lt, totalItems: ut, currentPage: dt } = n({
		columns: b,
		data: Se,
		enableRowSelection: C,
		rowSelection: De,
		onRowSelectionChange: Oe,
		selectedRowIds: ke,
		onSelectedRowIdsChange: Ae,
		enableSorting: w,
		sorting: je,
		onSortingChange: Me,
		expandable: k,
		subrows: A,
		pagination: Re,
		enableColumnResizing: j,
		columnResizeMode: ze,
		enableColumnReorder: M,
		onColumnOrderChange: Be,
		initialColumnOrder: Ve,
		getRowId: Ue,
		editable: R
	}), { sensors: ft, handleDragEnd: pt } = ue({
		enabled: L,
		getRows: () => W.getRowModel().rows,
		extractRowId: K,
		onRowReorder: Je
	}), X = k?.enabled ?? !1, mt = k?.expandToggleColumn ?? !0, ht = +!!C + (X && mt ? 1 : 0) + +!!L, Z = b.length + ht, Q = He ? {
		position: "sticky",
		top: typeof N == "number" ? `${N}px` : N,
		zIndex: 30
	} : {}, $ = W.getSelectedRowModel().rows, gt = $.map((e) => e.id), _t = $.map((e) => e.original), vt = C && $.length > 0, yt = () => W.getHeaderGroups().map((n) => /* @__PURE__ */ _(U, { children: [
		C && /* @__PURE__ */ g(H, {
			className: e("w-12.5 max-w-12.5 text-center bg-muted/50 border-b border-border", x === "bordered" && "border-r border-border justify-center"),
			style: {
				width: "50px",
				minWidth: "50px",
				maxWidth: "50px",
				...Q
			},
			children: /* @__PURE__ */ g("div", {
				className: "flex items-center w-full h-full max-w-content",
				children: /* @__PURE__ */ g(t, {
					checked: P === "page" ? W.getIsAllPageRowsSelected() : W.getIsAllRowsSelected(),
					indeterminate: P === "page" ? W.getIsSomePageRowsSelected() : W.getIsSomeRowsSelected(),
					onCheckedChange: () => {
						P === "page" ? W.toggleAllPageRowsSelected() : W.toggleAllRowsSelected();
					},
					"aria-label": "Select all rows",
					config: { size: "sm" }
				})
			})
		}),
		X && mt && /* @__PURE__ */ g(H, {
			className: e("w-12.5 max-w-12.5 text-center bg-muted/50 border-b border-border", x === "bordered" && "border-r border-border"),
			style: {
				width: "50px",
				minWidth: "50px",
				maxWidth: "50px",
				...Q
			}
		}),
		L && /* @__PURE__ */ g(H, {
			className: e("w-8 max-w-8 text-center bg-muted/50 border-b border-border", x === "bordered" && "border-r border-border"),
			style: {
				width: "32px",
				minWidth: "32px",
				maxWidth: "32px",
				...Q
			}
		}),
		(() => {
			let t = n.headers, r = ye(t.map((e, n) => {
				let r = e.column.columnDef, i = v(r), { width: a } = y(i, r, j, () => e.getSize());
				return {
					pinLeft: !!i.pinLeft || !!S?.leftFirst && n === 0,
					pinRight: !!i.pinRight || !!S?.rightLast && n === t.length - 1,
					width: ve(a)
				};
			}));
			return t.map((t, n) => {
				let i = t.column.columnDef, a = v(i), o = ot === t.column.id, s = st === n, c = r[n], { width: l, minWidth: u, maxWidth: d } = y(a, i, j, () => t.getSize()), f = () => o ? "translateY(-3px) scale(1.02)" : s && q ? "translateY(1px)" : "translateY(0px) scale(1)";
				return /* @__PURE__ */ g(pe.th, {
					colSpan: t.colSpan,
					className: e("h-9 py-2 font-medium text-muted-foreground bg-muted/50 text-xs leading-4.5", x === "numericCompact" ? "px-1" : "px-3.5", "border-b border-border", "transition-colors hover:bg-muted/80", t.column.getCanSort() && w && "cursor-pointer select-none", "relative group", _e(ge(a), "text-left"), x === "bordered" && "border-r border-border", s && q && "bg-primary/5", t.colSpan > 1 && "font-semibold bg-muted/80", c.side && xe(c.side, "header"), a.headerClassName),
					style: {
						width: l,
						minWidth: u,
						maxWidth: d,
						...Q,
						...c.side ? be(c) : {},
						opacity: o ? .8 : 1,
						transform: f(),
						transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)"
					},
					initial: {
						y: 0,
						scale: 1
					},
					animate: { transform: f() },
					transition: {
						type: "spring",
						stiffness: 500,
						damping: 50,
						duration: .15
					},
					whileHover: !o && M ? {
						backgroundColor: "rgba(59, 130, 246, 0.03)",
						transition: { duration: .15 }
					} : {},
					onClick: w && t.column.getCanSort() ? () => t.column.toggleSorting() : void 0,
					children: /* @__PURE__ */ _("div", {
						draggable: M,
						onDragStart: (e) => {
							M && (J.onDragStart(t.column.id), e.dataTransfer.setData("text/column-id", t.column.id), e.dataTransfer.effectAllowed = "move");
						},
						onDragOver: (e) => J.onDragOver(e, n),
						onDrop: (e) => J.onDrop(e, n),
						onDragEnd: J.onDragEnd,
						className: "flex items-center justify-between w-full h-full",
						children: [
							s && q && /* @__PURE__ */ g("div", { className: "absolute -left-0.5 top-0 bottom-0 w-1 bg-primary" }),
							/* @__PURE__ */ g("div", {
								className: "relative flex-1 text-[13px] font-medium text-foreground select-none",
								children: t.isPlaceholder ? null : me(t.column.columnDef.header, t.getContext())
							}),
							j && t.column.getCanResize() && /* @__PURE__ */ g("div", {
								onMouseDown: (e) => {
									e.stopPropagation(), t.getResizeHandler()(e);
								},
								onTouchStart: (e) => {
									e.stopPropagation(), t.getResizeHandler()(e);
								},
								className: e("absolute -right-1 top-0 h-full w-2 cursor-col-resize select-none touch-none opacity-0 hover:opacity-100 transition-opacity z-40 group-hover:opacity-100", t.column.getIsResizing() && "opacity-100 bg-primary"),
								role: "separator",
								"aria-orientation": "vertical",
								"aria-label": "Resize column"
							})
						]
					})
				}, t.id);
			});
		})()
	] }, n.id)), bt = (n, r) => {
		let i = tt.has(n.id), a = n.getIsExpanded(), o = A?.renderSubComponent && n.getCanExpand(), s = X && i && !!k?.renderExpandedContent || !!(o && a), c = [], l = Ne?.(n);
		return c.push(/* @__PURE__ */ _(U, {
			ref: r?.dragRef,
			"data-selected": n.getIsSelected(),
			"aria-label": T ? l : void 0,
			className: e("transition-colors duration-150", T ? "cursor-pointer hover:bg-muted/50 focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-ring focus-visible:-outline-offset-2" : void 0, n.getIsSelected() && "bg-primary/5", s && [
				"bg-primary/5",
				"[&>td:first-child]:shadow-[inset_3px_0_0_0_var(--primary)]",
				T && "hover:bg-primary/10"
			], typeof D == "function" ? D(n) : D),
			style: r?.dragStyle,
			onClick: (e) => {
				E ? he(e.target) || (e.metaKey || e.ctrlKey ? window.open(E(n), "_blank", "noopener") : T?.(n)) : T?.(n);
			},
			onAuxClick: E ? (e) => {
				e.button === 1 && !he(e.target) && window.open(E(n), "_blank", "noopener");
			} : void 0,
			tabIndex: T ? 0 : void 0,
			onKeyDown: T ? (e) => {
				e.target === e.currentTarget && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), T(n));
			} : void 0,
			children: [
				L && /* @__PURE__ */ g(V, {
					className: e("w-8 min-w-8 max-w-8 px-2 py-1.5 text-center select-none", x === "bordered" && "border-r border-border"),
					style: {
						width: "32px",
						minWidth: "32px",
						maxWidth: "32px"
					},
					children: /* @__PURE__ */ g(se, {
						...r?.dragAttributes ?? {},
						...r?.dragListeners ?? {}
					})
				}),
				C && /* @__PURE__ */ g(V, {
					className: e(ie({ variant: x === "bordered" ? "bordered" : "default" }), "p-0"),
					style: {
						width: "50px",
						minWidth: "50px",
						maxWidth: "50px"
					},
					onClick: (e) => e.stopPropagation(),
					children: /* @__PURE__ */ g("div", {
						className: "flex items-center pl-1.5 w-full h-full",
						children: /* @__PURE__ */ g(t, {
							checked: n.getIsSelected(),
							disabled: !n.getCanSelect(),
							onCheckedChange: () => n.toggleSelected(),
							"aria-label": `Select row: ${l ?? n.id}`,
							config: { size: "sm" }
						})
					})
				}),
				X && mt && (() => {
					let t = !k?.canExpand || k.canExpand(n.original);
					return /* @__PURE__ */ g(V, {
						className: e(ae({ variant: x === "bordered" ? "bordered" : "default" }), "p-0"),
						style: {
							width: "50px",
							minWidth: "50px",
							maxWidth: "50px"
						},
						children: /* @__PURE__ */ g("div", {
							className: "flex items-center justify-center",
							children: /* @__PURE__ */ g(ee, {
								isExpanded: t ? i : !1,
								onToggle: () => t ? at(n.id) : void 0,
								disabled: !t
							})
						})
					});
				})(),
				(() => {
					let t = n.getVisibleCells(), r = ye(t.map((e, n) => {
						let r = e.column.columnDef, i = v(r), a = y(i, r, j, () => e.column.getSize());
						return {
							pinLeft: !!i.pinLeft || !!S?.leftFirst && n === 0,
							pinRight: !!i.pinRight || !!S?.rightLast && n === t.length - 1,
							width: ve(a.width)
						};
					})), i = t.findIndex((e) => v(e.column.columnDef).rowHeader === !0);
					return t.map((t, a) => {
						let o = t.column.columnDef, s = v(o), c = y(s, o, j, () => t.column.getSize());
						if (A?.hideFirstCellInSubRows && a === 0 && n.depth > 0) return null;
						let l = me(t.column.columnDef.cell, t.getContext());
						if (l === null) return null;
						let u = s.editable === !0, d = W.getRowModel().rows.findIndex((e) => e.id === n.id), f = nt?.rowIndex === d && nt?.columnId === t.column.id, ee = R?.enabled && u && (R?.isCellEditable?.({
							row: n.original,
							columnId: t.column.id,
							rowIndex: d
						}) ?? !0), te = l;
						if (ee) {
							let e = t.getValue();
							te = /* @__PURE__ */ g(re, {
								value: e,
								row: n.original,
								columnId: t.column.id,
								rowIndex: d,
								isEditing: f,
								onStartEdit: () => G({
									rowIndex: d,
									columnId: t.column.id
								}),
								onSave: (e) => {
									G(null), R?.onCellEdit?.({
										rowIndex: d,
										columnId: t.column.id,
										value: e,
										row: n.original
									}), R?.onCellSave?.({
										rowIndex: d,
										columnId: t.column.id,
										value: e,
										row: n.original
									});
								},
								onCancel: () => G(null),
								renderEditCell: R?.renderEditCell
							});
						}
						let p;
						s.rowSpan && typeof s.rowSpan == "function" && (p = s.rowSpan(n));
						let ne = typeof s.cellClassName == "function" ? s.cellClassName(n) : s.cellClassName, m = r[a];
						return /* @__PURE__ */ g(V, {
							rowSpan: p,
							rowHeader: a === i || void 0,
							style: {
								...c,
								...a === 0 && n.depth > 0 && { paddingLeft: `${n.depth * 2 + .75}rem` },
								...s.hugContent ? { whiteSpace: "nowrap" } : {},
								...m.side ? be(m) : {}
							},
							className: e(p && p > 1 && "align-top border-r border-r-border", _e(ge(s)), s.numeric && "tabular-nums", m.side && xe(m.side, "cell"), ne),
							children: te
						}, t.id);
					});
				})()
			]
		}, n.id)), X && i && k?.renderExpandedContent && c.push(/* @__PURE__ */ g(te, {
			isExpanded: i,
			colSpan: Z,
			children: /* @__PURE__ */ g("div", {
				className: "p-4",
				children: k.renderExpandedContent(n)
			})
		}, `${n.id}-expanded`)), o && a && c.push(/* @__PURE__ */ g(U, {
			className: f,
			children: /* @__PURE__ */ g(V, {
				colSpan: Z,
				className: e("p-0", d),
				children: /* @__PURE__ */ g("div", {
					className: "p-4",
					children: A.renderSubComponent({ row: n })
				})
			})
		}, `${n.id}-sub`)), c;
	}, xt = ({ row: e, rowIndex: t }) => {
		let n = K(e, t), { setNodeRef: r, style: i, attributes: a, listeners: o } = de(n);
		return /* @__PURE__ */ g(h, { children: bt(e, {
			dragRef: r,
			dragStyle: i,
			dragAttributes: a,
			dragListeners: o
		}) });
	}, St = () => We ? /* @__PURE__ */ g(U, { children: /* @__PURE__ */ g(V, {
		colSpan: Z,
		className: "h-24 text-center",
		children: F?.loading ?? /* @__PURE__ */ _("div", {
			className: "flex items-center justify-center gap-2 text-muted-foreground",
			children: [/* @__PURE__ */ g("span", { className: "inline-block h-4 w-4 animate-spin rounded-full border-2 border-muted-foreground/30 border-t-transparent" }), "Loading..."]
		})
	}) }) : Ge ? /* @__PURE__ */ g(U, { children: /* @__PURE__ */ g(V, {
		colSpan: Z,
		className: "h-24 text-center text-muted-foreground",
		children: F?.error ?? Ge
	}) }) : W.getRowModel().rows?.length ? null : /* @__PURE__ */ g(U, { children: /* @__PURE__ */ g(V, {
		colSpan: Z,
		className: "h-24 text-center text-muted-foreground",
		children: Ke ?? F?.empty ?? Le
	}) }), Ct = () => St() || (L ? /* @__PURE__ */ g(oe, {
		sensors: ft,
		collisionDetection: le,
		onDragEnd: pt,
		children: /* @__PURE__ */ g(ce, {
			items: W.getRowModel().rows.map((e, t) => K(e, t)),
			strategy: fe,
			children: W.getRowModel().rows.map((e, t) => /* @__PURE__ */ g(xt, {
				row: e,
				rowIndex: t
			}, e.id))
		})
	}) : W.getRowModel().rows.flatMap((e) => bt(e))), wt = Y.show !== !1 && !(Object.keys(Y).length === 0 && ut <= lt) ? /* @__PURE__ */ g(ne, {
		config: Y,
		totalItems: ut,
		currentPage: dt,
		resolvedPageSize: lt,
		isClient: ct,
		setPagination: it,
		density: z === "sm" ? "compact" : "spacious"
	}) : null, Tt = !O?.title, Et = /* @__PURE__ */ _(h, { children: [Ye && /* @__PURE__ */ g("div", {
		className: "flex items-center justify-end gap-2 py-2",
		children: /* @__PURE__ */ g(m, { table: W })
	}), /* @__PURE__ */ _(s, {
		size: z,
		variant: x,
		truncate: {
			enabled: !!Te,
			maxLines: Ee ? 1 : 2
		},
		className: Pe,
		containerClassName: Xe,
		"aria-label": Ze,
		"aria-labelledby": Qe,
		bordered: !0,
		header: I && qe === "top" && vt ? /* @__PURE__ */ g(p, {
			selectedCount: $.length,
			selectedRowIds: gt,
			selectedRows: _t,
			bulkActions: I,
			position: "top"
		}) : null,
		footer: /* @__PURE__ */ _(h, { children: [I && qe === "bottom" && vt && /* @__PURE__ */ g(p, {
			selectedCount: $.length,
			selectedRowIds: gt,
			selectedRows: _t,
			bulkActions: I,
			position: "bottom"
		}), Tt ? wt : null] }),
		children: [/* @__PURE__ */ g($e, { children: yt() }), /* @__PURE__ */ g(et, { children: Ct() })]
	})] });
	return O?.title ? /* @__PURE__ */ _(u, {
		size: z,
		children: [
			/* @__PURE__ */ g(l, {
				title: O.title,
				badge: O.badge,
				description: O.description,
				contentTrailing: O.contentTrailing
			}),
			Et,
			wt
		]
	}) : /* @__PURE__ */ g("div", {
		className: "space-y-0",
		children: Et
	});
}
function Se(e) {
	return /* @__PURE__ */ g(b, {
		...e,
		pagination: {
			mode: "client",
			...e.pagination
		}
	});
}
function Ce(e) {
	return /* @__PURE__ */ g(b, {
		...e,
		pagination: {
			mode: "server",
			...e.pagination
		}
	});
}
function we(e) {
	return /* @__PURE__ */ g(b, {
		...e,
		pagination: {
			mode: "manual",
			...e.pagination
		}
	});
}
function x(e) {
	return /* @__PURE__ */ g(b, {
		...e,
		size: "sm",
		variant: "numericCompact"
	});
}
function S(e) {
	return /* @__PURE__ */ g(b, {
		...e,
		variant: "bordered"
	});
}
function Te(e) {
	return /* @__PURE__ */ g(b, {
		...e,
		variant: "borderless"
	});
}
function Ee(e) {
	let { renderExpandedContent: t, defaultExpanded: n, onExpandChange: r, expandToggleColumn: i = !0, canExpand: a, ...o } = e;
	return /* @__PURE__ */ g(b, {
		...o,
		expandable: {
			enabled: !0,
			renderExpandedContent: t,
			defaultExpanded: n,
			onExpandChange: r,
			expandToggleColumn: i,
			canExpand: a
		}
	});
}
export { S as BorderedTable, Te as BorderlessTable, b as DataTable, Se as DataTableClient, we as DataTableManual, Ce as DataTableServer, Ee as ExpandableDataTable, x as NumericCompactTable };

//# sourceMappingURL=DataTable.js.map